import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
import oneMemuBox from '../views/routerPage/oneMemuBox.vue'// 二级路由框
import twoMemuBox from '../views/routerPage/twoMenuBox.vue'// 三级路由框

Vue.use(Router);

// fix:修复控制台报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/loyaltyManagement'
    },
    {
      path: '/loyaltyManagement',
      component: oneMemuBox,
      children: [
        // 会员体系列表
        {
          path: "membershipSystem",
          name: "membershipSystem",
          component: () => import('../views/membershipSystem/index.vue')
        },
        // 新建会员体系
        {
          path: "newMembershipSystem",
          name: "newMembershipSystem",
          component: () => import('../views/newMembershipSystem/index.vue')
        },
        // 会员信息管理
        {
          path: 'memberMessageSystem',
          name: 'memberMessageSystem',
          component: twoMemuBox,
          children: [
            // 会员总览
            {
              path: 'memberAll',
              name: 'memberAll',
              component: () => import('../views/memberMessageSystem/memberAll.vue')
            },
            // 积分变更记录
            {
              path: 'integralRecord',
              name: 'integralRecord',
              component: () => import('../views/memberMessageSystem/integralRecord.vue')
            },
            // 等级变更记录
            {
              path: 'gradeRecord',
              name: 'gradeRecord',
              component: () => import('../views/memberMessageSystem/gradeRecord.vue')
            },
            // 成长值变更记录
            {
              path: 'growthRecord',
              name: 'growthRecord',
              component: () => import('../views/memberMessageSystem/growthRecord.vue')
            },
            // 待发放积分列表
            {
              path: 'waitSendScores',
              name: 'waitSendScores',
              component: () => import('../views/memberMessageSystem/waitSendScores.vue')
            },
            // 会员黑名单
            {
              path: 'memberBlacklist',
              name: 'memberBlacklist',
              component: () => import('../views/memberMessageSystem/blackList.vue')
            },
          ]

        },
        // 忠诚度管理
        {
          path: 'loyaltyManagement',
          name: 'loyaltyManagement',
          component: twoMemuBox,
          children: [
            // 会员卡配置
            {
              path: 'union_card',
              name: 'union_card',
              component: () => import('../views/loyaltyManagement/union_card.vue')
            },
            // 批量修改积分
            {
              path: 'modify_integral',
              name: 'modify_integral',
              component: () => import('../views/loyaltyManagement/modify_integral.vue')
            },
            // 会员体系设置
            {
              path: 'set_member_ship_system',
              name: 'set_member_ship_system',
              component: () => import('../views/loyaltyManagement/set_member_ship_system.vue')
            },
            // 积分发放规则
            {
              path: 'points_distribution_rules',
              name: 'points_distribution_rules',
              component: () => import('../views/loyaltyManagement/points_distribution_rules.vue')
            },
            // 成长值等级规则
            {
              path: "level_rules",
              name: "level_rules",
              component: () => import('../views/loyaltyManagement/level_rules.vue')
            },
            // 成长值计算规则
            {
              path: "growth_rules",
              name: "growth_rules",
              component: () => import('../views/loyaltyManagement/growth_rules.vue')

            }
          ]
        },
        // 会员通指南
        {
          path: 'memberGuide',
          name: 'memberGuide',
          component: twoMemuBox,
          children: [
            {
              path: 'tbMemberGuide',
              name: 'tbMemberGuide',
              beforeEnter() {
                window.open('https://www.yuque.com/yunduanxincrm/zegmqs/zgggan3qcrg47crr', '_blank');
              }
            },
            {
              path: 'jdMemberGuide',
              name: 'jdMemberGuide',
              beforeEnter() {
                window.open('https://www.yuque.com/yunduanxincrm/zegmqs/thcg1nvbx24s5rnu', '_blank');
              }
            },
            {
              path: 'dyMemberGuide',
              name: 'dyMemberGuide',
              beforeEnter() {
                window.open('https://www.yuque.com/yunduanxincrm/zegmqs/tx9r3krphdqsqsp9', '_blank');
              }
            },

          ]
        }
      ]
    },
    {
     path: "/redirection",
     name: "redirection",
     component: () => import('../views/routerPage/redirection.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/loginTest/index.vue'),
    },
    // 无数据页
    {
      path: '/nodata',
      name: 'nodata',
      component: oneMemuBox,
      children: [
        // 会员体系列表
        {
          path: "",
          name: "nodata",
          component: () => import('../views/nodata/index.vue'),
        },
      ]
    },
  ]
})

router.beforeEach((to, form, next) => {
  store.dispatch("updateActiveMenu", to.path);
  if (to.path === form.path) {
    next(false);
  } else {
    next();
  }

})
export default router